export default __webpack_public_path__ + "./ico-ok.4e5f1a2e449d8f16d491a0f1af671099.png";